import { BaseLayout } from "@components/general/base_layout";
import { Header } from "@components/general/header";
import { Outlet } from "react-router-dom";

import PreloadLogo from "@assets/images/logo-tarbiyatus.png";
import { useThemeStore } from "@stores/theme.store";
import { useEffect } from "react";

export const AuthPage = () => {
  const { setBottomNavigation } = useThemeStore((state) => state);
  useEffect(() => {
    setBottomNavigation("hidden");
  }, [setBottomNavigation]);
  return (
    <BaseLayout>
      <div className="tw-flex tw-flex-col tw-min-h-screen">
        <Header>
          <div className="tw-bg-background-100 page-title tw-relative tw-overflow-hidden">
            {/* Dekorasi lingkaran */}
            <div
              className="tw-absolute tw-top-2 tw-right-[-32px] tw-w-40 tw-h-40 tw-rounded-full"
              style={{ background: "rgba(34,197,94,0.07)" }}
            />
            <div
              className="tw-absolute tw-bottom-2 tw-left-[-24px] tw-w-28 tw-h-28 tw-rounded-full"
              style={{ background: "rgba(34,197,94,0.06)" }}
            />
            <div
              className="tw-absolute tw-top-1/2 tw-left-8 tw-w-12 tw-h-12 tw-rounded-full"
              style={{ background: "rgba(34,197,94,0.04)" }}
            />
            <div className="tw-pt-16 tw-pb-14 tw-text-center tw-relative tw-z-10">
              <img
                src={PreloadLogo}
                alt="Logo Tarbiyatus"
                className="tw-py-[72px] tw-w-4/5 tw-px-[0px] md:tw-w-2/4 lg:tw-w-1/3"
              />
            </div>
          </div>
        </Header>
        <Outlet />
      </div>
    </BaseLayout>
  );
};
